/**
 * Definição do module_lab para o registry frontend.
 *
 * Registra rotas no AppRouter via GameModule.routes. Em Fase 2 apenas uma
 * rota (LabRuntime placeholder). Rotas seguintes chegam em fases posteriores.
 */

import { lazy } from 'react'

import type { GameModule } from '../types'

const LabRuntime = lazy(() => import('./shell/LabRuntime'))
const LabPreview = lazy(() => import('./preview/LabPreview'))
const LabJoin = lazy(() => import('./join/LabJoin'))
const LabJoinQr = lazy(() => import('./join/LabJoinQr'))

export const ModuleLabModule: GameModule = {
  manifest: {
    id: 'module_lab',
    name: 'Lab',
    version: '0.1.0',
    description:
      'Jogos epistêmicos mediados por mestre humano. Alunos sincronizados, mestre conduz slides. Primeiro jogo: ATLAS.',
    icon: 'FlaskConical',
    // Mesmo com mestre autenticado via RPGIA, jogadores podem ser anônimos.
    // O AppRouter respeita requiredRole === 'any' não envolvendo em ProtectedRoute.
    requiredRole: 'any',
  },

  routes: [
    {
      path: '/mesa/:tableId/module_lab/:sessionId',
      component: LabRuntime,
      requiredRole: 'any',
      title: 'Lab — Runtime',
    },
    {
      path: '/module_lab/preview/:slug',
      component: LabPreview,
      requiredRole: 'any',
      title: 'Lab — Preview da aula',
    },
    {
      path: '/module_lab/join/:tableId',
      component: LabJoin,
      requiredRole: 'any',
      title: 'Lab — Entrar na aula',
    },
    {
      path: '/module_lab/qr/:tableId',
      component: LabJoinQr,
      requiredRole: 'any',
      title: 'Lab — QR code de entrada',
    },
  ],
}
